import axios from 'axios';
import { toastNotify } from './toastNotify';
import { notification } from 'antd';
import { ACCOUNT_FREEZE_ERROR_MESSAGE } from './constant';

import { store } from '../store/store';
import { resetUserData } from '../store/reducer/accountSlice';
const BASE_URL = process.env.REACT_APP_API_URL;
const REACT_APP_MAPBOX_API_URL = process.env.REACT_APP_MAPBOX_API_URL;

axios.defaults.headers = {
  'ngrok-skip-browser-warning': true,
};

const TEMP_HEADERS_PATHS = [
  `/api/v1/user/validate-pin`,
  `/api/v1/user/resend-email`,
  `/api/v1/user/pin`,
  `/api/v1/user/profile`,
  `/api/v1/user/reset-pin`,
  `/api/v1/user/password`,
  '/api/v1/user/account-reactivation-link',
];

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

function makeTempHeaders() {
  let headerObj = {};
  if (localStorage.getItem('access_token_temp')) {
    const token = `Bearer ${localStorage.getItem('access_token_temp')}`;
    headerObj = {
      Authorization: token,
    };
  }
  return headerObj;
}

function makeHeaders() {
  let headerObj = {};
  if (localStorage.getItem('access_token')) {
    const token = `Bearer ${localStorage.getItem('access_token')}`;
    headerObj = {
      Authorization: token,
    };
  }
  return headerObj;
}

const axiosApi = axios.create({
  baseURL: BASE_URL,
});

const resetUser = (error) => {
  const errorMessage = error?.response?.data?.message;
  
  // Store error message to show after redirect
  const messageToShow = errorMessage === 'FROZEN_ACCOUNT_ERROR' ? ACCOUNT_FREEZE_ERROR_MESSAGE : errorMessage;
  
  const prevPathname = window.location.pathname;
  store.dispatch(resetUserData());
  localStorage.clear();
  localStorage.setItem('prev_pathname', prevPathname);
  localStorage.setItem('login_error_message', messageToShow);

  return (window.location.href = '/login');
};

const getRefreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem('refresh_token');
    const response = await axios.post(
      `${BASE_URL}/api/v1/auth/access-token`,
      { refreshToken },
      {
        headers: makeHeaders(),
      }
    );

    localStorage.setItem('access_token', response.data?.data?.accessToken);
    // localStorage.setItem('refresh-token', response.data?.data?.refreshToken);
    // return response.data?.data?.accessToken;
    localStorage.setItem('prev_pathname', window.location.pathname);
    return (window.location.href = '/login/enterpin');
  } catch (error) {
    resetUser(error);
    // throw error;
  }
};

axiosApi.interceptors.request.use((request) => {
  // if (!request.ignoreAuth) {
  const { isPinEntered } = store.getState().userData;

  if (isPinEntered) {
    request.headers = request.headers['Authorization'] ? request.headers : makeHeaders();
  } else if (TEMP_HEADERS_PATHS.indexOf(request.url) !== -1) {
    request.headers = request.headers['Authorization'] ? request.headers : makeTempHeaders();
  }

  // request.headers = makeHeaders();
  // }
  return request;
});

axiosApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Global handler for FROZEN_ACCOUNT_ERROR
    if (error?.response?.data?.message === 'FROZEN_ACCOUNT_ERROR') {
      const width = window.innerWidth;
      notification.error({
        description: ACCOUNT_FREEZE_ERROR_MESSAGE,
        duration: 5,
        placement: width > 1024 ? 'bottomRight' : 'topRight',
      });
    }

    const originalRequest = error.config;

    // NOTE: if request is for logout then do not call for new access token
    if (error?.response?.request?.responseURL.startsWith(BASE_URL) && originalRequest?.url !== '/api/v1/logout') {
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');
      const tempAccessToken = localStorage.getItem('access_token_temp');

      if (error?.response?.data?.message === 'It looks that your account has been frozen. Please contact support@realbricks.com for more details.') {
        return Promise.reject(error);
      }      

      if (accessToken || tempAccessToken) {
        // if token is expired then only
        if (error?.response?.data?.message && [401, 403, 409].indexOf(error?.response?.status) !== -1 && !originalRequest._retry) {
          if(process.env.REACT_APP_WEBFLOW_LOGIN=== 'production'){
          document.cookie = `user_login=''; path=/; domain=.realbricks.com`;
          }
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            })
              .then((token) => {
                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                return axiosApi(originalRequest);
              })
              .catch((error) => {
                return Promise.reject(error);
              });
          }

          originalRequest._retry = true;
          isRefreshing = true;
          try {
            if (refreshToken === null) {
              resetUser(error);
              return Promise.reject(null);
            }

            if (error?.response?.data?.message === 'It looks that your account has been frozen. Please contact support for more details!') {
              return Promise.reject(error);
            }

            await getRefreshToken();

            // originalRequest.headers['Authorization'] = `Bearer ${responseToken}`;
            // processQueue(null, responseToken);
            return axiosApi(originalRequest);
          } catch (error) {
            processQueue(error, null);
            return Promise.reject(null);
          } finally {
            isRefreshing = false;
          }
        } else {
          if ([401, 403].indexOf(error?.response?.status) !== -1) {
            store.dispatch(resetUserData());
          }
          if (error?.response?.request?.responseURL.startsWith(BASE_URL) && [(401, 403)].indexOf(error?.response?.status) === -1) {
            return Promise.reject(error);
          } else {
            toastNotify(`error`, error?.response?.data?.message);
            return Promise.reject(null);
          }
        }
      }
    }
    // if (error.response && [401, 403].indexOf(error?.response?.status) !== -1 && error?.response?.request?.responseURL.startsWith(BASE_URL)) {
    //   removeCookie();
    //   localStorage.clear();
    //   if (error?.response?.data?.message !== 'It looks that your account has been frozen. Please contact support for more details!') {
    //     toastNotify(`error`, error?.response?.data?.message);
    //     return (window.location.href = '/login');
    //   }
    // }
    // returning rejected only if base url is from back-end and status code is not 401,403 or mapbox API
    if (
      (error?.response?.request?.responseURL.startsWith(BASE_URL) && [401, 403].indexOf(error?.response?.status) === -1) ||
      error?.response?.request?.responseURL.startsWith(REACT_APP_MAPBOX_API_URL)
    ) {
      return Promise.reject(error);
    }
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      store.dispatch(resetUserData());
    }
  }
);

export const realBricksApi = axiosApi;
